import { get } from '@webapp-next/lib/request/webapp/apiv2';

export async function getAddOnSubscriptions() {
  return await get('/api/v2/subscriptions/product/add-on');
}
